<template>
  <v-container>
    <v-row>
      <v-col class="xs-12" cols="12">
        <v-card>
          <v-toolbar>
            <v-toolbar-title class="ml-3 mr-3">TAKT.integration</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="showInfoText=!showInfoText"><v-icon>info</v-icon></v-btn>
          </v-toolbar>
          <v-alert v-if="showInfoText" type="info">
            Register clients and add them to your project to access the TAKT.api or get notified whenever something changes within your project using TAKT.callbacks.
            <br>
            <b>Clients</b> <br>
            A client consists of a <v-chip mall class="ma-2">name</v-chip> which you can pick freely, as well as a <v-chip mall class="ma-2">base uri</v-chip> which should be your API endpoint.<br>
            Clients you create will first be marked as <v-chip small class="ma-2" color="red" text-color="white">
              <v-avatar left>
                <v-icon>sync_disabled</v-icon>
              </v-avatar>
              inactive
            </v-chip>. TAKT.ing will check every registered client and then mark them as <v-chip small class="ma-2" color="green" text-color="white">
              <v-avatar left>
                <v-icon>sync</v-icon>
              </v-avatar>
              active
            </v-chip> as soon as possible. Now your client is ready to call against the TAKT.api and you can also register callbacks.
            <br>
            <b>Callbacks</b> <br>
            Callbacks are API endpoints of your API which TAKT.ing will call whenever a certain condition is met. A Callback consists of information about your API endpoint:<br>
            <v-chip small class="ma-2">callback http method</v-chip> (The HTTP method of your API that TAKT.ing should call)<br>
            <v-chip small class="ma-2">callback uri</v-chip> (The 2nd part of the callback endpoint, with the 1st part being the base url of the respective registered client.)<br>
            <v-chip small class="ma-2">TAKT.entity</v-chip> (The TAKT entity that this callback should observe.)<br>
            <v-chip small class="ma-2">TAKT HTTP method</v-chip> (The HTTP method called on the selected TAKT.entity.)<br>
            <br>
            <b>Payloads</b> <br>
            All Callbacks will send JSON data based on the entity attached.<br>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Entity</th>
                    <th class="text-left">JSON Payload</th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr>
                    <td><v-chip small outlined class="ma-2">Train</v-chip></td>
                    <td><vue-json-pretty :data="train_payload"></vue-json-pretty></td>
                  </tr>
                  <tr>
                    <td><v-chip small outlined class="ma-2">TaktArea</v-chip></td>
                    <td><vue-json-pretty :data="taktarea_payload"></vue-json-pretty></td>
                  </tr>
                  <tr>
                    <td><v-chip small outlined class="ma-2">TWaggon</v-chip></td>
                    <td><vue-json-pretty :data="twaggon_payload"></vue-json-pretty></td>
                  </tr>-->
                  <tr>
                    <td><v-chip small outlined class="ma-2">TWorkPackage</v-chip></td>
                    <td><vue-json-pretty :data="twork_package_payload"></vue-json-pretty></td>
                  </tr>
                  <!-- <tr>
                    <td><v-chip small outlined class="ma-2">TWorkStep</v-chip></td>
                    <td><vue-json-pretty :data="twork_step_payload"></vue-json-pretty></td>
                  </tr>
                  <tr>
                    <td><v-chip small outlined class="ma-2">TQualityStep</v-chip></td>
                    <td><vue-json-pretty :data="tquality_step_payload"></vue-json-pretty></td>
                  </tr>
                  <tr>
                    <td><v-chip small outlined class="ma-2">TDefectStep</v-chip></td>
                    <td><vue-json-pretty :data="tdefect_step_payload"></vue-json-pretty></td>
                  </tr>
                  <tr>
                    <td><v-chip small outlined class="ma-2">THandoverStep</v-chip></td>
                    <td><vue-json-pretty :data="thandover_step_payload"></vue-json-pretty></td>
                  </tr>
                  <tr>
                    <td><v-chip small outlined class="ma-2">TDesignStep</v-chip></td>
                    <td><vue-json-pretty :data="tdesign_step_payload"></vue-json-pretty></td>
                  </tr>
                  <tr>
                    <td><v-chip small outlined class="ma-2">TLogisticStep</v-chip></td>
                    <td><vue-json-pretty :data="tlogistic_step_payload"></vue-json-pretty></td>
                  </tr> -->
                </tbody>
              </template>
            </v-simple-table>
          </v-alert>
          <ProjectClientsList
            :project_clients="getProjectClients(this.project_id)" :current_user="getUser"
            @addClient="addClient($event)" @addCallback="addCallback($event)"
            @deleteClient="delClient($event)" @deleteCallback="delCallback($event)"
          />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import store from '@/store/index';
import router from '@/router/index';
// import StandardCard from '@/components/StandardComponents/StandardCard.component.vue'
import VueJsonPretty from 'vue-json-pretty'
import ProjectClientsList from '@/components/ProjectSettings/ProjectClientsList.component.vue'
import {
  mapGetters, mapActions
} from 'vuex';
export default {
  components: {
    ProjectClientsList, VueJsonPretty
  },
  name: 'ProjectClients',
  data: function() {
    return {
      showInfoText: false,
      train_payload: {
        id: '<Number>',
        name: '<String>',
        description: '<String>',
        train_start_dates: '<Date> Array',
        workable_backlog: '<Boolean>'
      },
      taktarea_payload: {
        id: '<Number>',
        square_meter: '<Number>',
        description: '<String>',
        name: '<String>',
        taktarea_start_dates: '<Date> Array'
      },
      twaggon_payload: {
        id: '<Number>',
        takt_dates: '<Date> Array'
      },
      twork_package_payload: {
        id: '<Number>',
        name: '<String>',
        project_id: '<Number>',
        project_name: '<String>',
        train_id: '<Number>',
        train_name: '<String>',
        taktarea_id: '<Number>',
        taktarea_name: '<String>',
        // token: '<String>',
        // icon: '<String>',
        // description: '<String>',
        // color: '<String>',
        // textcolor: '<String>',
        // manpower_planned: '<Number>',
        // manpower_actual: '<Number>',
        // duration_actual: '<Number>',
        // time_effort_planned: '<Number>',
        // quantity_value: '<Number>',
        // quantity_unit: '<String>',
        // contact_name: '<String>',
        // contact_phone_number: '<String>',
        // contact_email: '<String>',
        status: '<String>',
        takt_dates: '<<Array> Date>'
      },
      twork_step_payload: {
        id: '<Number>',
        text: '<String>',
        position: '<Number>',
        manpower_planned: '<Number>',
        done: '<Boolean>'
      },
      tquality_step_payload: {
        id: '<Number>',
        text: '<String>',
        position: '<Number>',
        offset: '<Number>',
        done: '<Boolean>'
      },
      tdefect_step_payload: {
        id: '<Number>',
        text: '<String>',
        position: '<Number>',
        offset: '<Number>',
        done: '<Boolean>'
      },
      thandover_step_payload: {
        id: '<Number>',
        text: '<String>',
        position: '<Number>',
        offset: '<Number>',
        done: '<Boolean>'
      },
      tdesign_step_payload: {
        id: '<Number>',
        text: '<String>',
        position: '<Number>',
        offset: '<Number>',
        done: '<Boolean>'
      },
      tlogistic_step_payload: {
        id: '<Number>',
        text: '<String>',
        position: '<Number>',
        offset: '<Number>',
        done: '<Boolean>'
      },
    }
  },
  beforeRouteEnter(to, from, next) {
    if (!store.getters['Project/hasProjectPermission']({
      project_id: to.params.project_id,
      ppermission: 'Read Invites'
    })) {
      router.push({
        name: 'ProjectSettings',
        params: {
          project_id: to.params.project_id
        }
      })
    } else {
      Promise.all([
        store.dispatch('Project/requestProjectClients', {
          project_id: to.params.project_id
        }),
      ])
      .then(res => {
        next(res);
      });
    }
  },
  created(){
    if (this.getProjectClients(this.project_id).length === 0) {
      this.showInfoText = true;
    }
  },
  computed: {
    ...mapGetters('Project', [
      'getProjectClients'
    ]),
    ...mapGetters('Auth', [
      'getUser',
    ]),
    project_id() {
      return parseInt(this.$route.params.project_id);
    },
  },
  methods: {
    ...mapActions('Project', [
      'createAndAddClientToProject',
      'createCallback',
      'deleteClient',
      'deleteCallback'
    ]),
    addClient(client){
      this.createAndAddClientToProject({
        project_id: this.project_id,
        client: client
      });
    },
    addCallback(callback){
      this.createCallback({
        project_id: this.project_id,
        callback: callback
      });
    },
    delClient(client_id){
      this.deleteClient({
        project_id: this.project_id,
        client_id: client_id
      });
    },
    delCallback(payload){
      this.deleteCallback({
        project_id: this.project_id,
        callback_id: payload.callback_id,
        client_id: payload.client_id
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.members-setting-default-height {
  max-height: 600px;
  overflow-y: auto;
}
</style>
